import React from 'react'

export default function Coupon() {
    return (
        <div>
<h1 className="text-[#000] font-AbrilFatface text-[30px] font-normal leading-normal text-center my-4"><b>Kategori Untukmu</b></h1>
        <div className='flex ml-[100px] mt-10 mb-[150px] gap-[30px]'>
            <div className="bg-[#fcfcfc] self-start flex flex-row gap-3 w-[381px] items-start rounded-lg shadow-md">
                <div className="bg-[#228f47] relative flex flex-col justify-end w-[146px] shrink-0 items-center pt-16 pb-6 px-6 rounded-tl-lg rounded-bl-lg">
                    <div className="text-5xl font-['Sequel_Sans'] font-black text-white absolute top-5 left-5 h-12 w-24">
                        90%
                    </div>
                    <div className="text-lg font-['Sequel_Sans'] font-light text-[#e7ffef] relative">
                        Semua Item!
                    </div>
                </div>
                <div className="flex flex-col mt-2 gap-1 w-3/5 h-24 items-start">
                    <div className="self-end relative flex flex-col mb-5  items-start">
                        <div className="border-solid border-[#228f47]  w-16 h-3 shrink-0 border rounded-sm mr-3">
                            <div className="text-[8px] font-['Sequel_Sans'] font-light absolute w-full ml-2 mb-1">
                                Promo Jumbo
                            </div>
                        </div>
                    </div>
                    <div className="text-xs font-['Sequel_Sans'] font-light">
                        Berlaku s/d{" "}
                        <div className="contents" id="BerlakuSdSeptember">
                            10 September 2023
                        </div>
                    </div>
                    <button className="flex flex-col mb-3 w-24 items-start">
                        <div className="bg-[#66bf84] flex flex-col w-24 items-center px-3 py-1 rounded-lg">
                            <div className="text-xs font-['Sequel_Sans'] font-light text-white">
                                Klaim Promo
                            </div>
                        </div>
                    </button>
                    <div className="text-[8px] font-['Sequel_Sans'] font-light self-end mr-3">
                        S&K Berlaku
                    </div>
                </div>
            </div>


            <div className="bg-[#fcfcfc] self-start flex flex-row gap-3 w-[381px] items-start rounded-lg shadow-md">
                <div className="bg-[#228f47] relative flex flex-col justify-end w-[146px] shrink-0 items-center pt-16 pb-6 px-6 rounded-tl-lg rounded-bl-lg">
                    <div className="text-5xl font-['Sequel_Sans'] font-black text-white absolute top-5 left-5 h-12 w-24">
                        20%
                    </div>
                    <div className="text-lg font-['Sequel_Sans'] font-light text-[#e7ffef] relative">
                        Semua Item!
                    </div>
                </div>
                <div className="flex flex-col mt-2 gap-1 w-3/5 h-24 items-start">
                    <div className="self-end relative flex flex-col mb-5  items-start">
                        <div className="border-solid border-[#228f47]  w-16 h-3 shrink-0 border rounded-sm mr-3">
                            <div className="text-[8px] font-['Sequel_Sans'] font-light absolute w-full ml-2 mb-1">
                                9.9 Deal
                            </div>
                        </div>
                    </div>
                    <div className="text-xs font-['Sequel_Sans'] font-light">
                        Berlaku s/d{" "}
                        <div className="contents" id="BerlakuSdSeptember">
                            10 September 2023
                        </div>
                    </div>
                    <button className="flex flex-col mb-3 w-24 items-start">
                        <div className="bg-[#66bf84] flex flex-col w-24 items-center px-3 py-1 rounded-lg shadow-md">
                            <div className="text-xs font-['Sequel_Sans'] font-light text-white">
                                Klaim Promo
                            </div>
                        </div>
                    </button>
                    <div className="text-[8px] font-['Sequel_Sans'] font-light self-end mr-3">
                        S&K Berlaku
                    </div>
                </div>
            </div>


            <div className="bg-[#fcfcfc] self-start flex flex-row gap-3 w-[381px] items-start rounded-lg shadow-md">
                <div className="bg-[#EBC351] relative flex flex-col justify-end w-[146px] shrink-0 items-center pt-16 pb-[52px] px-6 rounded-tl-lg rounded-bl-lg">
                    <div className="text-3xl text-center font-['Sequel_Sans'] font-black text-white absolute top-5 left-5 h-12 w-24">
                    Gratis Ongkir
                    </div>
                </div>
                <div className="flex flex-col mt-2 gap-1 w-3/5 h-24 items-start">
                    <div className="self-end relative flex flex-col mb-5  items-start">
                        <div className="border-solid border-[#228f47]  w-16 h-3 shrink-0 border rounded-sm mr-3">
                            <div className="text-[8px] font-['Sequel_Sans'] font-light absolute w-full ml-2 mb-1">
                                Free Shipment
                            </div>
                        </div>
                    </div>
                    <div className="text-xs font-['Sequel_Sans'] font-light">
                        Berlaku s/d{" "}
                        <div className="contents" id="BerlakuSdSeptember">
                            10 September 2023
                        </div>
                    </div>
                    <button className="flex flex-col mb-3 w-24 items-start">
                        <div className="bg-[#66bf84] flex flex-col w-24 items-center px-3 py-1 rounded-lg ">
                            <div className="text-xs font-['Sequel_Sans'] font-light text-white">
                                Klaim Promo
                            </div>
                        </div>
                    </button>
                    <div className="text-[8px] font-['Sequel_Sans'] font-light self-end mr-3">
                        S&K Berlaku
                    </div>
                </div>
            </div>


            <div className="bg-[#fcfcfc] self-start flex flex-row gap-3 w-[381px] items-start rounded-lg shadow-md">
                <div className="bg-[#EBC351] relative flex flex-col justify-end w-[146px] shrink-0 items-center pt-16 pb-[52px] px-6 rounded-tl-lg rounded-bl-lg">
                    <div className="text-3xl text-center font-['Sequel_Sans'] font-black text-white absolute top-5 left-5 h-12 w-24">
                    Gratis Ongkir
                    </div>
                </div>
                <div className="flex flex-col mt-2 gap-1 w-3/5 h-24 items-start">
                    <div className="self-end relative flex flex-col mb-5  items-start">
                        <div className="border-solid border-[#228f47]  w-16 h-3 shrink-0 border rounded-sm mr-3">
                            <div className="text-[8px] font-['Sequel_Sans'] font-light absolute w-full ml-2 mb-1">
                                Free Shipment
                            </div>
                        </div>
                    </div>
                    <div className="text-xs font-['Sequel_Sans'] font-light">
                        Berlaku s/d{" "}
                        <div className="contents" id="BerlakuSdSeptember">
                            10 September 2023
                        </div>
                    </div>
                    <button className="flex flex-col mb-3 w-24 items-start">
                        <div className="bg-[#66bf84] flex flex-col w-24 items-center px-3 py-1 rounded-lg ">
                            <div className="text-xs font-['Sequel_Sans'] font-light text-white">
                                Klaim Promo
                            </div>
                        </div>
                    </button>
                    <div className="text-[8px] font-['Sequel_Sans'] font-light self-end mr-3">
                        S&K Berlaku
                    </div>
                </div>
            </div>
            </div>
        </div>
        
    )
}
